/*
 * Public API Surface of kraken-spinner
 */

export * from './lib/kraken-spinner.service';
export * from './lib/kraken-spinner.component';
export * from './lib/kraken-spinner.module';
